import React from 'react'
import { Card, Divider, CardContent, Grid } from '@material-ui/core'
import { components, constants, useTranslation } from 'cng-web-lib'

import Namespace from 'src/constants/locale/Namespace'
import PingEventCodeMappingApiUrls from 'src/apiUrls/ping/PingEventCodeMappingApiUrls'
import PingEventSourceApiUrls from 'src/apiUrls/ping/PingEventSourceApiUrls'
import PingKeys from 'src/constants/locale/key/Ping'

const {
	card: { CngSimpleCardHeader },
	table: { CngCrudTable, useDefaultNotification, useFetchCustomLookup }
} = components
const { locale: { key: { UiComponentKeys } } } = constants

function TablePage(props) {

	const { location: { pathname }, showNotification } = props
	const notification = useDefaultNotification(showNotification)
	const { translate } = useTranslation([
		Namespace.UI_COMPONENT, Namespace.PING
	])
	const translatedTextsObject = makeTranslatedTextsObject()
	const fetchCustomLookup = useFetchCustomLookup();

	//* Translation function ---------------------------------------------------
	function makeTranslatedTextsObject() {

		let title = translate(Namespace.PING, PingKeys.SUB_MODULE_TITLE.PING_EVENT_CODE_MAPPING)

		let tableTitle = translate(
			Namespace.UI_COMPONENT,
			UiComponentKeys.Table.TITLE,
			{ nameTitleised: title }
		)

		// columns
		let eventSourceCode = translate(Namespace.PING, PingKeys.FIELDS.EVENT_SOURCE_CODE)
		let sourceEventCode = translate(Namespace.PING, PingKeys.FIELDS.SOURCE_EVENT_CODE)
		let mappedEventCode = translate(Namespace.PING, PingKeys.FIELDS.MAPPED_EVENT_CODE)
		let active = translate(Namespace.PING, PingKeys.FIELDS.ACTIVE)

		return {
			tableTitle,
			eventSourceCode,
			sourceEventCode,
			mappedEventCode,
			active
		}
	}

	//* Table Columns ----------------------------------------------------------
	const columns = [
		{
			field: 'eventSourceCode', title: translatedTextsObject.eventSourceCode,
			customLookup: () => {
				return fetchCustomLookup(
					PingEventSourceApiUrls.GET,
					{},
					'content',
					'code',
					'code'
				)
			}
		},
		{ field: 'sourceEventCode', title: translatedTextsObject.sourceEventCode },
		{ field: 'mappedEventCode', title: translatedTextsObject.mappedEventCode },
		{ field: 'active', title: translatedTextsObject.active, type: 'boolean' }
	];

	//* return JSX -------------------------------------------------------------
	return (

		//* Start JSX ----------------------------------------------------------
		<Card>
			<CngSimpleCardHeader title={translatedTextsObject.tableTitle} />
			<Divider />
			<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<CngCrudTable {...props}
							notification={notification}

							// table fetch and data details
							fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
							fetch={{ url: PingEventCodeMappingApiUrls.GET }}
							idAccessor='id'
							columns={columns}

							// view route
							viewRoute={`${pathname}/view`}

							// add route
							addRoute={`${pathname}/add`}

							// edit route
							editRoute={`${pathname}/edit`}

							// delete
							del={{ url: PingEventCodeMappingApiUrls.DELETE }}
						/>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
		//* End JSX ------------------------------------------------------------

	);

	//* End of function --------------------------------------------------------
}

export default TablePage
